import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import PGHero from '../components/PrasadGift/PGHero';
import Customer from '../components/Customer';
import OfferCard from '../components/AmritjalProductDetail/AmritjalSpray/OfferCard';
import AmritjalFooter from '../components/Amritjal_hp/AmritjalFooter';
import PGDarbar from '../components/PrasadGift/PGDarbar';
import PGBenefits from '../components/PrasadGift/PGBenefits';
import NavBar from '../components/Navbar';

const PrasadGift = () => {
  const { productId } = useParams();
     useEffect(() => {
       window.scrollTo(0, 0); // Ensure scrolling to the top happens immediately
   
     }, []);
  
  return (
    <div>
    <NavBar/>
    <PGHero productId={productId} />
    <PGDarbar productId={productId}/>
    <PGBenefits productId={productId}/>
    <OfferCard productId={productId}/>

    <Customer reviewFile={productId === "ramdarbar" ? "ramdarbar_reviews.json" : "krishnadarbar_reviews.json"}/>
    <AmritjalFooter/>
    </div>
  )
}

export default PrasadGift
